import Separator from "../../ComponentsLibrary/Separator"
import QRCode from "react-qr-code"
import { CampProps, ReservationProps } from "~/interfaces"
import moment from "moment"

interface Props {
  reservation: ReservationProps
  camp: CampProps
}

const ParkingPass: React.FC<Props> = (props) => {
  const { camp, reservation } = props
  const camper = reservation.user?.camper

  const lastName = camper?.last_name || reservation.user?.last_name
  const firstName = camper?.first_name || reservation.user?.first_name
  const licensePlate = camper?.license_plate || reservation?.user?.license_plate
  const hasHeader = camp.logo_url || camp.name
  const hasName = firstName || lastName
  const hasReservationId = reservation?.hashed_id
  const hasDates = reservation.start_date && reservation.end_date
  const invoiceUrl = `https://parkwith.us/i/${reservation?.hashed_id}`

  return (
    <div className="pagebreakafter">
      <div className="flex justify-center w-full print:h-[900px]">
        <div className="overflow-hidden">
          <div className="flex flex-col gap-y-6 border w-[450px] rounded-xl p-6">
            {hasHeader && (
              <div className="flex flex-col items-center gap-y-2">
                {camp.logo_url && <img alt={camp.name} src={camp.logo_url} className="w-[60px]" />}
                {camp.name && <p className="text-3xl text-center font-bold">{camp.name}</p>}
                <Separator dashed />
              </div>
            )}
            <div className="flex flex-col gap-y-6">
              <Item title="Lot" description={reservation.site?.name} />
              <Item
                title="Dates"
                description={
                  hasDates &&
                  `${moment(reservation.start_date).format("MM/DD")} - ${moment(reservation.end_date).format("MM/DD")}`
                }
              />

              <Item title="Name" description={hasName && `${firstName} ${lastName}`} />

              <Item title="License" description={licensePlate} />
              <Item title="Reservation" description={hasReservationId && `#${reservation?.hashed_id}`} />
            </div>
            <div className="relative mt-4">
              <div className="w-[80px] h-[80px] absolute left-[-80px] top-[-40px] border rounded-full bg-white" />
              <div className="w-[80px] h-[80px] absolute right-[-80px] top-[-40px] border rounded-full bg-white" />
              <Separator dashed />
            </div>

            <div className="flex justify-between mb-4 items-center">
              <div>
                <p className="text-gray-600 font-bold text-lg">Scan to see full invoice</p>
                <p className="text-gray-400 text-sm">{invoiceUrl}</p>
              </div>
              <QRCode value={invoiceUrl} size={90} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ParkingPass

const Item = ({ title, description }: { title: string; description?: string }) => {
  if (!description) return

  return (
    <div>
      <p className="text-gray-400 text-2xl">{title}</p>
      <p className="text-3xl font-bold">{description}</p>
    </div>
  )
}
